/**
 * General Note: Other control flag utilities can be found in t3-connected-widgets and Settings library.
 * They will be moved to Common Utilities with ticket WFSLAM-93.
 */

/**
 * Creates an array filter function to filter items that include the given control flag in their list of control flags.
 * Items need to have the controlFlag property.
 *
 * Example:
 *  const vehicles = [{ objectId: '1', controlFlags: ['edit'] }, { objectId: '2', controlFlags: [] }]
 *  const editableVehicles = vehicles.filter(createControlFlagFilter('edit'))
 *
 *
 * @param {string} controlFlag - control flag to be looked for
 * @return {function(*): boolean} - filter function
 */
const createControlFlagFilter = controlFlag => item =>
    !!(Array.isArray(item?.controlFlags) && item.controlFlags.find(flag => flag === controlFlag))

export { createControlFlagFilter }
